import './examples.component.scss'

import $ from 'jquery'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import Swiper, { Navigation, Autoplay } from 'swiper'
Swiper.use([Navigation, Autoplay])

$(document).ready(function () {
  new Swiper('.examples__slider .swiper-container', {
    slidesPerView: 2,
    spaceBetween: 20,
    autoHeight: true,
    loop: true,
    autoplay: {
      duration: 2500,
    },
    navigation: {
      prevEl: '.examples__slider-prev',
      nextEl: '.examples__slider-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      }
    }
  });
});